import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';

/**
 * firebase analytics action builders
 */

// 404 page visited
export const firebase404EventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: '404',
    },
  ],
};
export const firebase404VisitedAction: (url: string) => FirebaseActionTypes.IAnalyticsEventAction = (url) => {
  const newParam: FirebaseTypes.IEventParam = {
    key: 'url',
    value: url,
  };
  !!firebase404EventPayload.parameters && firebase404EventPayload.parameters.push(newParam);
  return FirebaseActions.analyticsEventAction(firebase404EventPayload);
};

// 401 event action
export const firebase401EventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: '401',
    },
  ],
};
export const firebase401EventAction: () => FirebaseActionTypes.IAnalyticsEventAction = () => {
  return FirebaseActions.analyticsEventAction(firebase401EventPayload);
};

// Unity not supported action
export const unityNotSupportedEventPayload: FirebaseTypes.IEventActionPayload = {
  eventName: 'Error_page',
  parameters: [
    {
      key: 'Error_code',
      value: 'unity',
    },
  ],
};
export const unityNotSupportedEventAction: () => FirebaseActionTypes.IAnalyticsEventAction = () => {
  return FirebaseActions.analyticsEventAction(unityNotSupportedEventPayload);
};
